var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"zi-dot-wrapper"},[_c('span',{staticClass:"zi-dot",class:[_vm.type]}),(_vm.$slots.default || _vm.label)?_c('span',{staticClass:"zi-dot-label"},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }